import * as React from 'react';
import { t } from 'i18next';

import { ArStore } from '../../stores/ArStore';
import { GlobalHelper } from '../../utils/GlobalHelper';
import { BaseComponent } from '../BaseComponent';
import { ClickButton } from '../ClickButton';
import { ToolsActions } from '../../actions/ToolsActions';
import { SceneStore } from '../../stores/SceneStore';

interface ArButtonState {
    active: boolean;
    show: boolean;
    elementsInView: boolean;
}

export class ArButton extends BaseComponent<{}, ArButtonState> {
    public componentWillMount(): void {
        this.addStoreListener(ArStore, this.onChange);
        this.addStoreListener(SceneStore, this.onChange);
        this.onChange();
    }

    public render(): JSX.Element | null {
        if (!this.state.show) {
            return null;
        }
        return (
            <ClickButton className="smart-button ar-button" callback={this.onClick} disabled={!this.state.elementsInView}>
                <div className="smart-button-label">{t('AR mode')}</div>
            </ClickButton>
        );
    }

    protected onClick = (): void => {
        if (this.state.active) {
            GlobalHelper.arManager.core.leaveAr();
        } else {
            GlobalHelper.arManager.core.enterAr();
        }
        ToolsActions.hideSmartExtra();
    };

    protected onChange = () => {
        this.setState({
            show: ArStore.getState().arDevice,
            active: ArStore.getState().started,
            elementsInView: SceneStore.getState().elementCount > 0,
        });
    };
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ar/ARButton.tsx